module.exports = __webpack_public_path__ + "static/media/mentorBadge.e2beb3be.png";